import moment, { Moment } from 'moment';
import React from 'react';
import GridFilter from '../../../../Base/Components/GridFilter/GridFilter';
import GridFilterItem from '../../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../../Base/Enums/GridFilterItemType.enum';
import { useAppContext } from '../../../../../Services/AppContext';
import useFilters from '../../../../Base/Hooks/useFilters';
import { GRID_FILTER_KEYS } from '../../../../Base/Components/GridFilter/gridFilterKeys';
import { SelectValue } from '../../../../../Components/Base/Select/Select';

export interface AssignedCasesFilterValues {
	createdAt?: Moment | string;
	patientId?: string;
	caseStatusValue?: string;
	caseTypeIds?: string[];
	onlyVisible: boolean;
	workplaceId: string;
}

interface Props {
	onFilter: (values: AssignedCasesFilterValues) => void;
}

const AssignedCasesFilter: React.FC<Props> = ({ onFilter }) => {
	const { workplaceId } = useAppContext();
	const { checkEmptyString } = useFilters();
	const onFilterData = (values: any) => {
		const filter: AssignedCasesFilterValues = {
			createdAt: values?.createdAt
				? moment(values.createdAt).format('YYYY-MM-DD')
				: undefined,
			patientId: checkEmptyString(values?.patient?.value),
			caseStatusValue: values?.caseStatus?.value,
			caseTypeIds: values?.caseTypeIds?.length
				? values.caseTypeIds.map((item: SelectValue) => item.value)
				: undefined,
			onlyVisible: true,
			workplaceId,
		};
		onFilter(filter);
	};

	return (
		<GridFilter
			onChange={onFilterData}
			storageKey={GRID_FILTER_KEYS.ASSIGNED_CASES_FILTER}>
			<GridFilterItem
				type={GridFilterItemType.CASE_STATUS}
				width={340}
				enableAutocomplete
				customPlaceholder='base.shared.pick'
			/>
			<GridFilterItem
				type={GridFilterItemType.PATIENT_ID}
				width={320}
				customPlaceholder='base.startTypingSurname'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.CREATED_AT}
				width={190}
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.CASE_TYPE}
				width={340}
				customPlaceholder='base.shared.pick'
				enableAutocomplete
			/>
		</GridFilter>
	);
};

export default AssignedCasesFilter;
